import useHomeType from 'hooks/useHomeType'
import Monitoring from '../Monitoring/Monitoring'

export const RotaMonitoringScreen = () => {
  const { hasRota } = useHomeType()

  if (!hasRota) {
    return null
  }

  return <Monitoring />
}
